<script setup lang="ts">
import Calculator from '@presentation/Icons/Calculator.vue';
import { LINKS } from '@presentation/Types/Settings';

</script>

<template>
    <Page>
        <div class="w-full grid grid-cols-5">
            <a class="rounded-lg bg-white/5 hover:bg-white/10 transition duration-150 p-4 flex flex-col aspect-video items-center justify-center"
                target="_blank"
                :href="LINKS.Calculators">
                <Calculator />
                <div>Calculators</div>
            </a>
        </div>
    </Page>
</template>